import { normalizeError, setStorageItem } from '@mx/pay-common';
import { AccessSource, bridge, env, monitor } from '@/common';

function callbackNativeRouter(resultCode: number, resultData: CallbackNativeRouterDataTyep) {
  monitor.captureInfo('[info]callbackNativeRouter', { resultCode, resultData });
  // 若接入方是web-cashier，则只setResult promotion，由web-cashier打开结果页
  // pay.notifyHybridProcessResult桥只适用于支付流程结束，通知Native支付结果，而独立签约和待支付页没有支付流程，故使用setResult
  if (!env.isIndependenceSign && env.useNewCashierCallback && env.access_source !== AccessSource.WebCashier) {
    notifyProcessResultAndClosePage(resultData);
  } else {
    KNB.setResult({
      resultCode,
      resultData: JSON.stringify(resultData),
      success: bridge.closePage,
      fail: bridge.closePage,
    });
  }
}
function notifyProcessResultAndClosePage(resultData: CallbackNativeRouterDataTyep) {
  monitor.captureInfo('[info]notifyProcessResultAndClosePage', { ...resultData });
  if (resultData.action === 'downgrade' && env.isIOS) {
    // iOS端使用 pay.notifyHybridProcessResult 无法关闭前置收银台，故使用 setResult
    // 通知 Native，同时把自身关闭
    KNB.setResult({
      resultCode: (KNB.setResult as any).RESULT_OK,
      resultData: JSON.stringify(resultData),
      success: bridge.closePage,
      fail: bridge.closePage,
    });
  } else {
    // 先用后付的页面用不了自建桥，只能先调用 KNB 桥，以下代码直接走到catch
    bridge.notifyKNBHybridProcessResultAndClosePage(resultData).catch((err) => {
      monitor.captureJSErrorMessage('[bridge]notifyKNBHybridProcessResultAndClosePage调用失败', {
        error: normalizeError(err),
      });
    });
  }
}
/**
 * 待支付页支付成功，给业务方回调
 */
export function paymentPaySuccess() {
  console.log('待支付页支付成功::');
  KNB.setResult({
    resultCode: (KNB.setResult as any).RESULT_OK,
    resultData: JSON.stringify({
      status: 'success',
    }),
    success: bridge.closePage,
    fail: bridge.closePage,
  });
}
/**
 * 待支付页支付失败或取消，给业务方回调
 */
export function paymentPayFailOrCancel() {
  console.log('待支付页支付失败或取消::');
  KNB.setResult({
    resultCode: (KNB.setResult as any).RESULT_OK,
    resultData: JSON.stringify({
      status: 'fail',
    }),
    success: bridge.closePage,
    fail: bridge.closePage,
  });
}
/**
 * 取消开通先用后付
 * 支付流程签约
 */
function cancelDeferCashier() {
  console.log('支付取消::');
  callbackNativeRouter((KNB.setResult as any).RESULT_CANCELED, {
    action: 'finish',
    status: 'cancel',
    pay_result_extra: JSON.stringify({ signStatus: false }),
  });
}

/**
 * 取消开通先用后付
 * 独立签约
 */
function cancelDeferIndependence() {
  // resultCode 获取到的值为 -1
  callbackNativeRouter((KNB.setResult as any).RESULT_CANCELED, {
    status: 'cancel',
  });
}

/**
 * 取消开通先用后付
 * 独立签约+支付流程签约
 */
export function cancelDefer() {
  if (env.isIndependenceSign) {
    cancelDeferIndependence();
  } else {
    cancelDeferCashier();
  }
}

/**
 * 先用后付支付成功
 * 支付流程签约
 */
export function deferCashierPaySuccess(promotion?: Record<string, any>) {
  console.log('支付成功::');
  setStorageItem('PAY_DEFER_SUCCESS_TRADENO', env.inpayBasicBusinessParams.tradeno);
  callbackNativeRouter((KNB.setResult as any).RESULT_OK, {
    promotion,
    action: 'finish',
    status: 'success',
    pay_result_extra: JSON.stringify({ signStatus: true, isDefer: true }),
  });
}

/**
 * 先用后付签约成功
 * 独立签约
 */
export function deferIndependenceSignSuccess() {
  // resultCode 获取到的值为 -1
  callbackNativeRouter((KNB.setResult as any).RESULT_OK, {
    status: 'success',
  });
}

/**
 * 先用后付垫付
 * 支付流程签约
 */
export function deferCashierUnknownPayStatus(promotion?: Record<string, any>) {
  console.log('可能是垫付::');
  callbackNativeRouter((KNB.setResult as any).RESULT_OK, {
    promotion,
    action: 'finish',
    status: 'success',
    pay_result_extra: JSON.stringify({ payStatus: 'unknown' }),
  });
}

/**
 * 先用后付支付失败
 * 降级至标准收银台进行支付
 * 支付流程签约
 */
export function downgradeStandardCashier() {
  console.log('支付降级::');
  callbackNativeRouter((KNB.setResult as any).RESULT_OK, {
    action: 'downgrade',
    dest_cashier_type: 'hybrid_standard_cashier',
    source_cashier_type: 'pay_defer_sign',
    downgrade_info: '',
    pay_result_extra: JSON.stringify({ signStatus: 'fail' }),
  });
}

/**
 * 先用后付签约失败
 * 独立签约
 */
export function deferIndependenceSignFail(error?: any) {
  // resultCode 获取到的值为 -1
  callbackNativeRouter((KNB.setResult as any).RESULT_OK, {
    status: 'fail',
    pay_result_extra: JSON.stringify(error),
  });
}

/**
 * 先用后付（原安心付）支付中签约或支付成功
 */
export function delayPayCashierPaySuccess(promotion?: Record<string, any>) {
  console.log('支付成功::');
  notifyProcessResultAndClosePage({
    promotion,
    action: 'finish',
    status: 'success',
    source_cashier_type: 'delaypay',
    pay_result_extra: JSON.stringify({ signStatus: true, isDefer: true }),
  });
}
/**
 * 先用后付（原安心付）支付或支付中降级
 */
export function delayPaydowngradeStandardCashier() {
  notifyProcessResultAndClosePage({
    action: 'downgrade',
    dest_cashier_type: 'hybrid_standard_cashier',
    source_cashier_type: 'delaypay',
    downgrade_info: '',
    pay_result_extra: JSON.stringify({ signStatus: 'fail' }),
  });
}
/**
 * 先用后付（原安心付）支付或支付中取消，按理说此支付模式在失败取消时都会降级到标准收银台，
 * 不会给业务方此回调
 */
export function cancelDelayPayCashier() {
  console.log('支付取消::');
  notifyProcessResultAndClosePage({
    action: 'finish',
    status: 'cancel',
    source_cashier_type: 'delaypay',
    pay_result_extra: JSON.stringify({ signStatus: false }),
  });
}
